import React from 'react';

import { LazyQuestion } from '../lazyComponents';

export function QuestionRoute() {
	return <LazyQuestion />;
}

QuestionRoute.NAVIGATION_PARAMS = ({ spaceKey, questionId }) => ({
	Screen: {
		screenEvent: {
			name: 'questionScreen',
			questionId,
		},
		pageState: { spaceKey },
	},

	MainLayout: {
		spaceKey,
	},
});
